
// @ts-nocheck


export const localeCodes =  [
  "ua"
]

export const localeLoaders = {
  "ua": [{ key: "../lang/ua.js", load: () => import("../lang/ua.js" /* webpackChunkName: "locale__usr_src_app_lang_ua_js" */), cache: true },
{ key: "../lang/ua.js", load: () => import("../lang/ua.js" /* webpackChunkName: "locale__usr_src_app_lang_ua_js" */), cache: true },
{ key: "../lang/ua.js", load: () => import("../lang/ua.js" /* webpackChunkName: "locale__usr_src_app_lang_ua_js" */), cache: true },
{ key: "../lang/ua.js", load: () => import("../lang/ua.js" /* webpackChunkName: "locale__usr_src_app_lang_ua_js" */), cache: true },
{ key: "../lang/ua.js", load: () => import("../lang/ua.js" /* webpackChunkName: "locale__usr_src_app_lang_ua_js" */), cache: true }]
}

export const vueI18nConfigs = [
  () => import("../i18n.options.ts?hash=ef6a39e1&config=1" /* webpackChunkName: "i18n_options_ts_ef6a39e1" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "i18n.options.ts",
  "locales": [
    {
      "code": "ua",
      "domain": "rmonkey.org",
      "language": "ua_UA",
      "files": [
        "/usr/src/app/lang/ua.js",
        "/usr/src/app/lang/ua.js",
        "/usr/src/app/lang/ua.js",
        "/usr/src/app/lang/ua.js",
        "/usr/src/app/lang/ua.js"
      ]
    }
  ],
  "defaultLocale": "ua",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": true,
  "langDir": "lang/",
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "http://localhost:3000/",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "country": "UA",
  "seo": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "ua",
    "domain": "rmonkey.org",
    "language": "ua_UA",
    "files": [
      {
        "path": "/usr/src/app/lang/ua.js"
      },
      {
        "path": "/usr/src/app/lang/ua.js"
      },
      {
        "path": "/usr/src/app/lang/ua.js"
      },
      {
        "path": "/usr/src/app/lang/ua.js"
      },
      {
        "path": "/usr/src/app/lang/ua.js"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
